import type { Translations } from '../../types'

const systemStatusMessages: Translations = {
  "systemStatus.subtitle": "Panoramica health dei servizi con polling ogni 20 secondi.",
  "systemStatus.lastUpdated": "Ultimo aggiornamento {{time}}",
  "systemStatus.refresh": "Aggiorna",
  "systemStatus.refreshing": "Aggiornamento...",
  "systemStatus.status.ok": "OK",
  "systemStatus.status.degraded": "Degradato",
  "systemStatus.status.down": "Down",
  "systemStatus.card.latency": "Latenza",
  "systemStatus.card.lastChecked": "Ultimo check",
  "systemStatus.card.source": "Payload",
  "systemStatus.card.errorPrefix": "Errore:",
  "systemStatus.card.payload": "Payload più recente",
  "systemStatus.empty": "In attesa di dati. Il servizio di stato aggiorna in automatico.",
  "systemStatus.toast.loadError": "Impossibile caricare lo stato dei servizi.",
  "systemStatus.loginRequired": "Fai login per vedere lo stato dei servizi.",
  "systemStatus.analytics.period.7d": "Ultimi 7 giorni",
  "systemStatus.analytics.period.90d": "Ultimi 90 giorni",
  "systemStatus.analytics.period.2y": "Ultimi 2 anni",
  "systemStatus.analytics.avgLatency": "Latenza media",
  "systemStatus.analytics.peakLatency": "Latenza di picco",
  "systemStatus.analytics.minLatency": "Latenza minima",
  "systemStatus.analytics.incidents": "Incidenti",
  "systemStatus.analytics.uptime": "uptime",
  "systemStatus.analytics.latencyTrend": "Andamento latenza",
  "systemStatus.analytics.healthPerformance": "Salute e performance del servizio",
  "systemStatus.trace.tabs.info": "Informazioni trace",
  "systemStatus.trace.tabs.request": "Dettagli request",
  "systemStatus.trace.tabs.response": "Dettagli response"
}

export default systemStatusMessages
